<template>
    <div>
        <div style="height: 20vh;" class="inapp-hide"></div>
        <Riassunto :iscrizione="true"/>

        <div class="race-app-header inapp-show"></div>

        <div class="v-step step" v-bind:class="{ 'active': step === 0 }"
             @click="focusStep" @keyup.enter.stop="next()">
            <div class="k-card" style="width:100%">
                <div class="k-card-body" style="width:100%">
                    <div class="k-card-img" style="height: 200px; width: 200px;">
                        <img :src="testi_donazione.maglia_img">
                    </div>
                    <div class="k-card-text" style="font-size:120%" v-if="team">
                        Hai deciso di sostenere {{team.name}}!<br><br>
                        <strong>ATTENZIONE:</strong> questa non è un’iscrizione alla Race ma stai facendo una donazione per incoraggiare e supportare questo team!
                    </div>
                </div>
            </div>
            <div class="v-step__footer-step">
                <b-button class="v-step__next-btn" @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 1 }"
             @click="focusStep" @keyup.enter.stop="next(check_indirizzo)">
            <b-form-group label="Dati del donatore">
                <b-input type="email"
                         v-model="form.donatore_email"
                         :state="state('donatore_email')"
                         placeholder="E-Mail donatore"
                         data-vv-name="donatore_email"
                         data-vv-as="E-Mail"
                         v-validate="'required|email'"
                         key="donatore_email"
                ></b-input>
                <span v-if="errors.has('donatore_email')" class="error">{{ errors.first('donatore_email') }}</span>

                <b-input type="text"
                         v-model="form.donatore_nome"
                         :state="state('donatore_nome')"
                         placeholder="Nome donatore"
                         ref="nome"
                         data-vv-name="nome"
                         data-vv-as="nome"
                         v-validate="'required|name'"
                         key="name"></b-input>
                <span v-if="errors.has('donatore_nome')"  class="error">{{ errors.first('donatore_nome') }}</span>

                <b-input @keyup.native.enter.stop="next"
                         type="text"
                         ref="cognome"
                         v-model="form.donatore_cognome"
                         :state="state('donatore_cognome')"
                         data-vv-name="donatore_cognome"
                         placeholder="Cognome donatore"
                         data-vv-as="donatore_cognome"
                         v-validate="'required|name'"
                         key="donatore_cognome"></b-input>
                <span v-if="errors.has('donatore_cognome')" class="error">{{ errors.first('donatore_cognome') }}</span>

                <b-input @keyup.native.enter.stop="next"
                         type="text"
                         ref="donatore_ragionesociale"
                         v-model="form.donatore_ragionesociale"
                         :state="state('donatore_ragionesociale')"
                         data-vv-name="donatore_ragionesociale"
                         placeholder="Ragione Sociale ( se azienda )"
                         data-vv-as="donatore_cognome"
                         key="donatore_ragionesociale"></b-input>

                <b-input @keyup.native.enter.stop="next"
                         type="text"
                         ref="donatore_piva"
                         v-model="form.donatore_piva"
                         :state="state('donatore_piva')"
                         data-vv-name="donatore_piva"
                         placeholder="P.IVA ( se azienda )"
                         data-vv-as="donatore_piva"
                         key="donatore_piva"></b-input>

                <b-input @keyup.native.enter.stop="next"
                         type="text"
                         ref="donatore_cf"
                         v-model="form.donatore_cf"
                         :state="state('donatore_cf')"
                         :disabled="prima_iscrizione && form.id > 0"
                         data-vv-name="donatore_cf"
                         placeholder="Codice Fiscale"
                         data-vv-as="donatore_cf"
                         key="donatore_cf"></b-input>
            </b-form-group>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 2 }"
             @keyup.enter.stop="next()"
             @click="focusStep">
                <b-form-group label="Desideri lasciare un messaggio di ringraziamento pubblico sulla bacheca?">
                <b-input type="text"
                         v-model="form.motivazione"
                         placeholder="Messaggio di ringraziamento (opzionale)"
                         key="motivazione"
                ></b-input>

            </b-form-group>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 3 }"
             @keyup.enter.stop="next(step_ok_donextra)"
             v-if="testi_donazione !== null"
             @click="focusStep">
            <b-form-group
                    label="Quanto desideri donare?"
            >
                <div class="k-card" style="width:100%">
                    <div class="k-card-body" style="width:100%">
                        <div class="k-card-img mx-auto">
                            <img :src="testi_donazione.path_img" class="img-fluid">
                        </div>
                        <div class="k-card-text mx-auto" style="font-size:120% !important;">
                            <div class="k-card-text--title">{{ testi_donazione.titolo }}</div>
                            <div class="k-card-text--description" v-html="testi_donazione.testo"></div>
                            <a @click="show_modale_progetto" class="k-card-text--btn cursor_pointer">Dettagli
                                Progetto</a>
                        </div>
                    </div>
                </div>


                <b-form-radio-group v-model="form.don_extra" name="don_extra" @input="checkFocus">
                    <b-form-radio :value="10"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono 10&euro;
                    </b-form-radio>
                    <b-form-radio :value="20"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono 20&euro;
                    </b-form-radio>
                    <b-form-radio :value="50"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono 50&euro;
                    </b-form-radio>

                    <b-form-radio value="extra"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline"
                                  ref="extra">
                        Importo libero
                        <b-input-group class="bg-transparent border-0 text-dark" append="&euro;">
                            <b-input type="text"
                                     v-model="form.don_extra_importo"
                                     :state="state('don_extra_importo')"
                                     append="€"
                                     class="v-form-control v-form-control__euro"
                                     placeholder="Scrivi l'importo desiderato"
                                     data-vv-name="don_extra_importo"
                                     data-vv-as="importo donazione extra"
                                     @keyup.native.enter.stop="next"
                                     @input="focusExtra"
                                     ref="inp_extra"
                                     v-validate="'decimal'"
                                     key="extra"
                            ></b-input>
                        </b-input-group>
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button
                        :disabled="!step_ok_donextra"
                        class="v-step__next-btn" variant="primary"
                        @click="next">Continua
                </b-button>
            </div>
        </div>

        <div class="v-step v-step__next step" v-bind:class="{ 'active': step === 4 }" @click="focusStep" v-if="donazione_totale > 0">
            <div class="v-step__next__title">Seleziona la modalità di donazione</div>
            <div class="v-step__next__subtitle">Totale <span>{{ donazione_totale }} &euro;</span></div>
            <div class="d-inline-block payment_select">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="paypal_selected" name="metodo_pagamento"
                           class="custom-control-input"
                           value="PAYPAL"
                           v-model="form.metodo_pagamento"
                    >
                    <label class="custom-control-label" for="paypal_selected">
                        <img src="/static/svg/icons/paypal.svg" height="50">
                    </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="gestpay_selected" name="metodo_pagamento"
                           class="custom-control-input"
                           value="GESTPAY"
                           v-model="form.metodo_pagamento"
                    >
                    <label class="custom-control-label" for="gestpay_selected">
                        <img src="/static/svg/icons/credit_card.svg" height="40"> <span class="small">Carta di credito</span>
                    </label>
                </div>
                <!--<div class="custom-control custom-radio custom-control-inline">-->
                <!--<input type="radio" id="bonifico_selected" name="metodo_pagamento"-->
                <!--class="custom-control-input"-->
                <!--value="BONIFICO"-->
                <!--v-model="tipo_pagamento"-->
                <!--&gt;-->
                <!--<label class="custom-control-label d-flex align-items-center small" for="bonifico_selected">Bonifico-->
                <!--bancario</label>-->
                <!--</div>-->
            </div>
            <div class="w-100 mt-3">
                <div class="btn btn-sm v-step__next-btn btn-primary font-weight-bold text-uppercase" @click="dona">Procedi</div>
            </div>
        </div>

        <b-modal ref="modale_progetto" centered class="modal__race" lazy hide-footer>
            <div v-html="html_modale"></div>
        </b-modal>

        <div class="text-center pb-8">
            <div v-if="partner_principale" class="text-uppercase small pb-1">Partner</div>
            <div v-if="partner_principale" class="d-block pb-4 partner">
                <img :src=partner_principale height="60" class="img-fluid">
            </div>

            <!--<div v-if="partner_secondari" class="text-uppercase small pb-1">Local Major Partner</div>-->
            <div v-if="partner_secondari" class="d-block partner">
                <img :src=partner_secondari height="40">
            </div>
        </div>
        <div style="height: 30vh;"></div>
    </div>
</template>

<script>
    import BaseForm from "../BaseForm";
    import Riassunto from "./Riassunto";

    export default {
        name: "SostieniInserimentoDati",
        extends: BaseForm,
        components: {Riassunto},
        mounted() {
            this.form.id_race = this.$store.state.id_race
            this.$http.get('/race/form/inserimento_dati/?type=province').then(response => {
                this.province = response.data.province
            }, () => {
                this.$notify({text:'C\'è stato un problema nel processare la tua richiesta, riprova più tardi',duration:10,type:'warn'})
            })
        },
        data() {
            return {
                form: {
                    don_extra: null,
                    don_extra_importo: null,
                    donatore_piva: null,
                    donatore_ragionesociale: null,
                    donatore_cognome: null,
                    donatore_nome: null,
                    donatore_cf: null,
                    donatore_email: null,
                    metodo_pagamento: null,
                    motivazione: null,
                    check_generico: null,
                },
                html_modale: null,
                province: null,
                submit_loader: false
            }
        }, methods: {
            dona() {
                this.submit_loader = true;
                this.$store.dispatch({
                    type: 'submit',
                    data: this.form,
                    id_form: this.id_form,
                    url: '/race/form/sostieni_squadra',
                    retry: 1
                }).then((response) => {
                    this.submit_loader = false
                    window.location.replace(response.data.redirect)
                }, () => {
                    this.submit_loader = false
                })
            }, checkFocus() {
                if (this.form.don_extra !== 'extra')
                    this.form.don_extra_importo = '';
            }, focusExtra() {
                if (this.form.don_extra_importo === '') return
                if (this.form.don_extra === 'extra') return
                this.form.don_extra = 'extra'

                if (this.$refs.extra)
                    this.$refs.extra.$el.querySelector('input').checked = true
            }, show_modale_progetto() {
                let elem = document.getElementById('modale_progetto')
                this.html_modale = elem.innerHTML
                this.$refs.modale_progetto.show()
            }
        }, computed: {
            testi_donazione() {
                let testi = this.$store.state.testi_donazione
                if (testi === null) testi = {}
                return testi
            }, step_ok_donextra() {
                if (this.form.don_extra === null) return false
                if (this.form.don_extra === 'extra') {
                    if (this.form.don_extra_importo <= 0) return false
                }
                return true
            },team() {
                return this.$store.getters.team
            },check_indirizzo() {
                return this.compiled('donatore_email','donatore_nome','donatore_cognome')
            },donazione_totale() {
                let extra = 0
                if (this.form.don_extra != null) {
                    if (this.form.don_extra === 'extra') {
                        extra = parseInt(this.form.don_extra_importo)
                        if (isNaN(extra)) extra = 0
                    } else
                        extra = parseInt(this.form.don_extra)
                }
                return extra
            }
        }
    }
</script>

<style scoped>

</style>
